import React from 'react';
import { Button } from '@sm/wds-react';

const EnterprisePackageCta = () => {
  return (
    <Button
      className="sm-package__btn sm-package__btn--enterprise"
      href="/mp/contact-sales/"
      stretched
      data-testid="EnterprisePackageCta__Btn"
    >
      CONTACT US
    </Button>
  );
};

export default EnterprisePackageCta;
